import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SessionStore } from './session.store';

export const passwordChangeGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const sessionStore = inject(SessionStore);
  if (!(await authService.ensureValidSession())) return router.createUrlTree(['/login']);
  return sessionStore.snapshot()?.mustChangePassword ? true : router.createUrlTree(['/app']);
};
